var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.236,
    height: 37.099,
    viewBox: "0 0 47.236 37.099",
    className: "img curved-arrow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ar{fill:#ccc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M68.933,47.236l-2.552-2.552,4.326-4.326A25.483,25.483,0,0,1,47.061,0l2.913,2.13A21.877,21.877,0,0,0,73.36,36.17l-6.979-6.979,2.552-2.552,10.3,10.3Z",
    transform: "translate(0 79.232) rotate(-90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrow);
export default __webpack_public_path__ + "static/media/curved-arrow.78d3a64968efafa8c5425ad183739870.svg";
export { ForwardRef as ReactComponent };